(function () {
  const TYPE_WRAP = '.variant-input-wrap[data-index="option1"]';
  const SIZE_WRAP = '.variant-input-wrap[data-index="option2"]';
  const TYPE_RADIOS = `${TYPE_WRAP} input[type="radio"]`;
  const TYPE_SELECT = `${TYPE_WRAP} select`;
  const SIZE_RADIOS = `${SIZE_WRAP} input[type="radio"]`;
  const SIZE_SELECT = `${SIZE_WRAP} select`;

  // SS 14.09.2026 - loaded on every product page now (one template): bail out on products without a Type + Størrelse pair
  if (!document.querySelector(TYPE_WRAP) || !document.querySelector(SIZE_WRAP)) return;
  // SS 27.10.2026 - family products have exactly two options; a third (sock 3-pack: one size per pair) is not Type + Size,
  // and reading «41-46 / 36-40 / 36-40» as type / size hid every button in option 2
  if (document.querySelector('.variant-input-wrap[data-index="option3"]')) return;

  // --- helpers ---
  const getTypeVal = () => {
    const r = document.querySelector(`${TYPE_WRAP} input[type="radio"]:checked`);
    if (r) return (r.value || '').trim();
    const s = document.querySelector(TYPE_SELECT);
    return s ? (s.value || '').trim() : '';
  };

  // Build allowed sizes for a type by reading the hidden no-JS select
  function getAllowedSizesFor(typeVal) {
    const sel = document.querySelector('select.product-single__variants.no-js');
    if (!sel || !typeVal) return null;

    const allowed = new Set();
    sel.querySelectorAll('option').forEach(o => {
      const left = (o.textContent || '').split(' - ')[0].trim(); // e.g. "Dame / S"
      const parts = left.split('/');
      if (parts.length >= 2) {
        const type = parts[0].trim();
        const size = parts.slice(1).join('/').trim();
        if (type.toLowerCase() === typeVal.toLowerCase()) {
          allowed.add(size);
        }
      }
    });
    return allowed;
  }

  // --- filter radios ---
  function filterSizeRadios() {
    const typeVal = getTypeVal();
    const radios = Array.from(document.querySelectorAll(SIZE_RADIOS));
    if (!radios.length) return false;

    const allowed = getAllowedSizesFor(typeVal);
    let checkedVisible = false;

    radios.forEach(r => {
      const holder = r.closest('label,.variant-input') || r.parentElement;
      const label = (r.getAttribute('data-option-value') || r.value || '').trim();
      const show = allowed ? allowed.has(label) : true;

      if (holder) holder.style.display = show ? '' : 'none';
      r.dataset._vf_visible = show ? '1' : '0';
      if (!show && r.checked) r.checked = false;
      if (show && r.checked && !r.disabled) checkedVisible = true;
    });

    // SS 30.09.2026 - family sweaters share size values across Types («S» for both Dame and Herre), and Shopify orders
    // option values by first appearance, so Herre XXS lands after Dame 5XL. Show the visible sizes in the order of the
    // chosen Type's variants (the no-js select follows variant order). Only when they share one parent: the kids groups
    // (ss-kids-groups.js) move buttons into their own boxes and are left alone
    if (allowed) {
      const order = Array.from(allowed);
      const shown = radios.filter(r => r.dataset._vf_visible === '1').map(r => ({
        h: r.closest('label,.variant-input') || r.parentElement,
        i: order.indexOf((r.getAttribute('data-option-value') || r.value || '').trim())
      }));
      const parent = shown.length ? shown[0].h.parentNode : null;
      if (parent && shown.every(x => x.h.parentNode === parent)) {
        const sorted = shown.slice().sort((a, b) => a.i - b.i);
        if (sorted.some((x, k) => x.h !== shown[k].h)) sorted.forEach(x => parent.appendChild(x.h));
      }
    }

    if (!checkedVisible) {
      // Dmytro-Claude - family products that open with nothing chosen (data-ss-nopre, see assets/dmytro-claude-nopreselect.js):
      // the customer picks the size, we don't pick one for them
      if (document.querySelector('[data-ss-nopre]')) return true;
      const first = radios.find(r => r.dataset._vf_visible === '1' && !r.disabled);
      if (first) {
        first.checked = true;
        first.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      const cur = radios.find(r => r.dataset._vf_visible === '1' && r.checked);
      if (cur) cur.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  // --- filter select ---
  function filterSizeSelect() {
    const sel = document.querySelector(SIZE_SELECT);
    if (!sel) return false;

    const typeVal = getTypeVal();
    const allowed = getAllowedSizesFor(typeVal);
    const all = Array.from(sel.options);

    const keep = allowed
      ? all.filter(o => !o.value || allowed.has((o.textContent || o.value).trim()))
      : all;

    const prev = sel.value;
    sel.innerHTML = '';
    keep.forEach(o => {
      const opt = new Option(o.text, o.value, false, false);
      opt.disabled = o.disabled;
      sel.appendChild(opt);
    });

    const canKeep = keep.some(o => o.value === prev && !o.disabled);
    if (canKeep) {
      sel.value = prev;
    } else {
      const first = Array.from(sel.options).find(o => o.value && !o.disabled) || sel.options[0];
      if (first) sel.value = first.value;
    }
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  // SS 14.09.2026 - two-line kids grid only while the visible sizes are kids sizes (value with a parenthesis)
  function toggleTwoLine() {
    const fs = document.querySelector(SIZE_WRAP); if (!fs || !fs.classList.contains('ss-two-line')) return;
    const visible = Array.from(fs.querySelectorAll('.variant-input')).filter(v => v.style.display !== 'none' && !v.hidden && v.offsetParent);
    fs.classList.toggle('ss-two-line-active', visible.some(v => /\(/.test(v.dataset.value || '')));
  }
  function apply() {
    if (!filterSizeRadios()) filterSizeSelect();
    toggleTwoLine();
  }

  // ---- scheduler ----
  let scheduled = false;
  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  };

  // ---- init ----
  let bound = false;
  let mo = null;

  function init() {
    if (bound) return;
    bound = true;

    scheduleApply();
    setTimeout(scheduleApply, 60);
    setTimeout(scheduleApply, 180);

    // Type change
    document.addEventListener('change', e => {
      if (e.target.matches(TYPE_RADIOS) || e.target.matches(TYPE_SELECT)) {
        scheduleApply();
      }
    });

    // Click fallback
    document.addEventListener('click', e => {
      if (e.target.closest(TYPE_WRAP) && (e.target.closest('label,[role="radio"],button,input[type="radio"]'))) {
        scheduleApply();
      }
    });

    // Watch size wrap
    const node = document.querySelector(SIZE_WRAP);
    if (node && !mo) {
      mo = new MutationObserver(() => scheduleApply());
      mo.observe(node, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  ['shopify:section:load','shopify:section:select','shopify:block:select'].forEach(e =>
    document.addEventListener(e, init)
  );
})();
